import { atom } from 'recoil'

export const modalTrustedSmsSenderCodeRequestState = atom({
  key: 'taskModalTrustedSmsSenderCodeRequestState',
  default: {
    show: false
  }
})

export const modalSmsSenderState = atom({
  key: 'taskModalSmsSenderState',
  default: {
    show: false,
    alias: undefined
  }
})

export const modalUsedMessageState = atom({
  key: 'taskModalusedState',
  default: {
    show: false,
    entityName: '',
    entityType: '',
    type: undefined,
    idMessage: 0
  }
})

export const modalFilterDetailState = atom({
  key: 'taskModalFilterDetails',
  default: {
    show: false
  }
})

export const modalSimulate = atom({
  key: 'taskModalSimulate',
  default: {
    show: false,
    idTask: undefined,
    idSimulate: undefined,
    fetchData: false,
    currentIteration: 0,
    interval: 0,
    simulateStatus: undefined,
    simulateProcessed: undefined,
    simulateDiscarded: undefined
  }
})
